import { render, staticRenderFns } from "./HotlineNumber.vue?vue&type=template&id=573c39e0&scoped=true&"
import script from "./HotlineNumber.vue?vue&type=script&lang=js&"
export * from "./HotlineNumber.vue?vue&type=script&lang=js&"
import style0 from "./HotlineNumber.vue?vue&type=style&index=0&id=573c39e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573c39e0",
  null
  
)

export default component.exports